/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FixedTwoDecimal } from '../../../../app/Utils/_helpers/string'
import clsx from 'clsx'
import { REGION } from '../../../../app/Utils/Constant/ConstantForWebsite'
import useWallet from './useWallet'
import { useNavigate } from 'react-router-dom'
import { useInboxResponsive } from '../../../../app/pages/UserPages/inbox-v2/useInboxResponsive'

type WalletProps = {
  remainingCredit?: (credit: number) => void
};

const WalletV2 = ({ remainingCredit }: WalletProps) => {
  const { credits, isShowCredit, shareCreditRemain, isDefaultRegion, userRegion } = useWallet({ remainingCredit })
  const navigate = useNavigate()

  const handleRedirect = () => {
    navigate('/topup')
  }

  // Check if it's mobile
  const {isMobile} = useInboxResponsive()
  
  // Mobile layout (vertical)
  if (isMobile) {
    return (
      <div className='d-flex flex-column'>
        <div>
          <div style={{ cursor: 'pointer' }} className='d-flex align-items-center px-4 py-2 fw-boldest wallet wheat_text_wallet hover-scale'>
            <div className='pe-2 hover-text'>
              <span>Email :</span>
            </div>
            <span className='fs-7 fw-boldest mb-0 hover-text'>0</span>
          </div>
        </div>

        <div className='border-top border-2 pt-2'>
          <div style={{ cursor: 'pointer' }} className='d-flex align-items-center px-4 py-2 fw-boldest wallet green_text_wallet hover-scale' onClick={handleRedirect}>
            <div className='pe-2 hover-text'>
              <span>SMS :</span>
            </div>
            <span className='fs-7 fw-boldest mb-0 hover-text'>
              {isShowCredit
                ? `${FixedTwoDecimal(credits?.credits?.sms || 0)}`
                : `${shareCreditRemain.sms} ${shareCreditRemain.type}`}
            </span>
          </div>
        </div>

        <div
          className={clsx(
            'border-top border-2 pt-2 fw-boldest',
            { 'd-none': !isDefaultRegion && ![REGION.US, REGION.UK].includes(userRegion) }
          )}
        >
          <div
            style={{ cursor: 'pointer' }}
            className='d-flex align-items-center px-4 py-2 fw-boldest wallet blue_text_wallet hover-scale'
            onClick={handleRedirect}
          >
            <div className='pe-2 hover-text'>
              <span>MMS :</span>
            </div>
            <span className='fs-7 fw-boldest mb-0 hover-text'>
              {isShowCredit
                ? `${FixedTwoDecimal(credits?.credits?.mms || 0)}`
                : `${shareCreditRemain.mms} ${shareCreditRemain.type}`}
            </span>
          </div>
        </div>
      </div>
    )
  }

  // Desktop layout (horizontal)
  return (
    <div className='d-flex gap-2'>
      <div>
        <div style={{ cursor: 'pointer' }} className='d-flex align-items-center px-4 pb-1 fw-boldest wallet wheat_text_wallet hover-scale'>
          <div className='pe-2 hover-text'>
            <span>Email :</span>
          </div>
          <span className='fs-7 fw-boldest mb-0 hover-text'>0</span>
        </div>
      </div>

      <div className='border-start border-2 ps-4'>
        <div style={{ cursor: 'pointer' }} className='d-flex align-items-center px-4 pb-1 fw-boldest wallet green_text_wallet hover-scale' onClick={handleRedirect}>
          <div className='pe-2 hover-text'>
            <span>SMS :</span>
          </div>
          <span className='fs-7 fw-boldest mb-0 hover-text'>
            {isShowCredit
              ? `${FixedTwoDecimal(credits?.credits?.sms || 0)}`
              : `${shareCreditRemain.sms} ${shareCreditRemain.type}`}
          </span>
        </div>
      </div>

      <div
        className={clsx(
          'border-start border-2 ps-4 fw-boldest',
          { 'd-none': !isDefaultRegion && ![REGION.US, REGION.UK].includes(userRegion) }
        )}
      >
        <div
          style={{ cursor: 'pointer' }}
          className='d-flex align-items-center px-4 pb-1 fw-boldest wallet blue_text_wallet hover-scale'
          onClick={handleRedirect}
        >
          <div className='pe-2 hover-text'>
            <span>MMS :</span>
          </div>
          <span className='fs-7 fw-boldest mb-0 hover-text'>
            {isShowCredit
              ? `${FixedTwoDecimal(credits?.credits?.mms || 0)}`
              : `${shareCreditRemain.mms} ${shareCreditRemain.type}`}
          </span>
        </div>
      </div>
    </div>
  )
}

export { WalletV2 }
